import { render, staticRenderFns } from "./AiHistory.vue?vue&type=template&id=d32782fc&scoped=true"
import script from "./AiHistory.vue?vue&type=script&lang=js"
export * from "./AiHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32782fc",
  null
  
)

export default component.exports